










































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { TypeformForm } from '@/api/model/typeform/typeform-form'
import { TypeformField } from '@/api/model/typeform/typeform-field'
import { TypeformLogicJumpFlattenedCondition } from '@/api/model/typeform/typeform-logic-jump-flattened-condition'
import { TypeformMap } from '@/api/model/typeform/typeform-map'
import { isEqual } from 'lodash'
import { TypeformResponseAnswerHook } from '@/api/model/typeform/typeform-response-answer-hook'
import HighlightReferences from '@/views/Typeform/Responses/Detail/HighlightReferences.vue'

@Component({
    components: {
        HighlightReferences,
    },
})
export default class LogicJumpPopOutCondition extends Vue {
    @Prop({ required: true }) readonly index!: number
    @Prop({ required: true }) readonly value!: string|boolean|number|Date
    @Prop({ required: true }) readonly hook!: TypeformResponseAnswerHook
    @Prop({ required: true }) readonly form!: TypeformForm
    internalValue: string|boolean|number|Date = null
    deleteHover: boolean = false

    @Watch('value', { immediate: true })
    onValueChanged() {
        this.internalValue = this.value
        this.autoSelectRightVar()
    }

    @Watch('internalValue', { deep: true })
    onInternalValueChanged() {
        if (isEqual(this.internalValue, this.value)) {
            return
        }

        this.$emit('input', {
            index: this.index,
            value: this.internalValue,
        })
    }

    autoSelectRightVar(): void {
        if (this.internalValue !== null) {
            return
        }

        if (this.fieldType === 'choice' && this.rightVarOptions.length) {
            this.internalValue = this.rightVarOptions[0].value
        } else if (this.fieldType === 'date') {
            this.internalValue = new Date().toISOString()
        } else if (this.fieldType === 'file') {
            this.internalValue = true
        }

        this.onInternalValueChanged()
    }

    get rightVarOptions() {
        const fieldType = this.fieldType
        if (fieldType !== 'choice') {
            return []
        }

        if (this.field.type === 'yes_no') {
            return [
                { label: this.$t('yes'), value: true },
                { label: this.$t('no'), value: false },
            ]
        }

        const options = []
        const choices = this.field.properties.choices as TypeformMap[]
        choices.forEach(choice => {
            options.push({
                label: choice.label,
                value: choice.label,
            })
        })

        return options
    }

    get field(): TypeformField|null {
        return this.form.fields.find(field => field.id === this.hook.fieldId)
    }

    get fieldType(): string|null {
        return TypeformLogicJumpFlattenedCondition.getFieldType(this.field)
    }

    get isDeletable(): boolean {
        return true
    }

    onDelete() {
        this.$emit('delete')
    }
}
